import React from 'react';
import MypagePaymentHistoryCotanier from 'containers/MypagePaymentHistoryCotanier';

export default function MypagePaymentHistoryPage() {
  return <MypagePaymentHistoryCotanier />;
}
